import React from "react";
import { Link } from "react-router-dom";

const YourPreparation = () => {
  return (
    <div className="h-screen w-full relative">
      <div
        className="absolute top-0 left-0 right-0 bottom-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url("http://localhost:3000/static/media/3rd.19634d627e575789ce48.jpg")',
          zIndex: -1, 
        }}
      />
      <div className="absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-b from-black via-black to-black opacity-80 z-0" />
      <div className="h-full w-full flex justify-center items-center relative z-10">
        <div className="text-center text-white">
          <p className="font-semi-bold text-3xl sm:text-4xl md:text-5xl mb-6">
            Boost Your CRT Preparation With <br />
            Industry Leaders
          </p>
          <div className="flex justify-center gap-3 py-6">
            <Link to="/about">
              <button className="primary-btn text-white py-2 px-3 rounded-md text-lg hover:bg-blue-600 transition duration-300">
                Learn More
              </button>
            </Link>
            <Link to="/contact">
              <button className="secondary-btn text-white py-2 px-3 rounded-md text-lg border border-white transition duration-300">
                Contact Us
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YourPreparation;
